import React, { Component } from 'react';

export class Home extends Component {
  static displayName = Home.name;

  render () {
    return (
      <div>
        <h1>Hello, world!</h1>
        <h5>Welcome to the Inbound SMS Hub where we will delight you with webhooks and inbound SMS messages!</h5>        
      </div>
    );
  }
}
